import Image from 'next/image';
import ios from './ios.svg';
import android from './android.svg';
import amazon from './amazon.svg';
import ibooks from './ibooks.svg';

/**
 * Bar that includes our apps and test prep books
 **/
function AppsBar() {
  return (
    <div className="py-4 bg-[#fbfbfb] border-y border-t-light-alt">
      <div className="container-xl text-xl font-bold text-center mb-4">
        Download our free learning tools apps and test prep books
      </div>
      <div className="container-xl flex flex-row justify-center items-center m-4 flex-wrap">
        <a
          className="bg-black p-3 rounded m-2 shadow-lg"
          href="https://itunes.apple.com/us/developer/varsity-tutors/id866311651"
          rel="noreferrer"
          target="_blank"
          title="Varsity Tutors Learning Tools App on Apple App Store"
        >
          <Image alt="varsity tutors app store" height={42} src={ios} width={148} />
        </a>
        <a
          className="bg-black p-3 rounded m-2 shadow-lg"
          href="https://play.google.com/store/apps/developer?id=Varsity+Tutors+LLC"
          rel="noreferrer"
          target="_blank"
          title="Varsity Tutors Learning Tools App on Google Play Store"
        >
          <Image alt="varsity tutors google play store" height={42} src={android} width={148} />
        </a>
        <a
          className="bg-black p-3 rounded m-2 shadow-lg"
          href="https://www.amazon.com/Varsity-Tutors/e/B01K8RF7DO/ref=sr_tc_2_0?qid=1471907165&sr=8-2-ent"
          rel="noreferrer"
          target="_blank"
          title="Varsity Tutors Study Guide eBooks on Amazon"
        >
          <Image
            alt="varsity tutors amazon store"
            className="h-[42px]"
            height={42}
            src={amazon}
            width={148}
          />
        </a>
        <a
          className="bg-black p-3 rounded m-2 shadow-lg"
          href="https://itunes.apple.com/us/author/varsity-tutors/id1106003119"
          rel="noreferrer"
          target="_blank"
          title="Varsity Tutors Study Guide eBooks on iBooks"
        >
          <Image alt="varsity tutors ibooks store" height={42} src={ibooks} width={148} />
        </a>
      </div>
    </div>
  );
}

export default AppsBar;
